module.exports = __webpack_public_path__ + "img/tea2.37b73684.png";